import { render, staticRenderFns } from "./SocialHappeningsTab.vue?vue&type=template&id=9c8bb3ca&scoped=true&"
import script from "./SocialHappeningsTab.vue?vue&type=script&lang=js&"
export * from "./SocialHappeningsTab.vue?vue&type=script&lang=js&"
import style0 from "./SocialHappeningsTab.vue?vue&type=style&index=0&id=9c8bb3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8bb3ca",
  null
  
)

export default component.exports